import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AuthenticationType } from 'authentication/shared/types'
import { YesObject } from '@yes.technology/react-toolkit'

type UseLogoutOnInaccessibleHomeArgs = {
  homeSitemodels: YesObject[]
  isFetchedHome: boolean
}

const useLogoutOnInaccessibleHome = ({
  homeSitemodels,
  isFetchedHome
}: UseLogoutOnInaccessibleHomeArgs) => {
  const dispatch = useDispatch()
  const { token, tokenType } = useSelector(
    ({ authentication }: AuthenticationType) => authentication
  )

  const isUserLogged = token && tokenType === 'private'
  const hasHomeSitemodels = homeSitemodels.length > 0

  useEffect(() => {
    if (isUserLogged && isFetchedHome && !hasHomeSitemodels) {
      dispatch({ type: 'login/LOGOUT_REQUEST' })
    }
  }, [dispatch, isUserLogged, isFetchedHome, hasHomeSitemodels])
}

export default useLogoutOnInaccessibleHome
